import React, { Component } from 'react';
import styled from 'styled-components';

import { H2 } from 'components/Typography';

const NavigationSection = styled.div`
  margin: 0 0 25px;

  &:last-child {
    margin: 0;
  }
`;

const NavigationTitle = H2.extend`
  color: #14acd0;
  margin: 0 0 25px;
  font-size: 28px;
  text-align: center;
  text-transform: uppercase;
`;

class NavSection extends Component {
  render() {
    return (
      <NavigationSection>
        <NavigationTitle>{this.props.title}</NavigationTitle>
        {this.props.children}
      </NavigationSection>
    );
  }
}

export default NavSection;



// WEBPACK FOOTER //
// ./src/components/Menu/NavSection.js